import { request } from '@/helpers/apiClient'
import { REWARDS_CONFIG } from '@/utils/constants/apiConfig/rewardsConfig'

/**
 * Get reward types from API
 * @returns {Promise} Promise containing reward types data
 */
export const getRewardTypes = async () => {
  return request(REWARDS_CONFIG.REWARD_TYPES)
}

/**
 * Get reward segments from API
 * @returns {Promise} Promise containing reward segments data
 */
export const getRewardSegments = async () => {
  return request(REWARDS_CONFIG.REWARD_SEGMENTS)
}

/**
 * Save reward as draft
 * @param {Object} rewardData - The reward data to save
 * @returns {Promise} Promise containing the save response
 */
export const saveRewardDraft = async (rewardData) => {
  return request(REWARDS_CONFIG.SAVE_DRAFT, { data: rewardData })
}

/**
 * Publish reward
 * @param {Object} rewardData - The reward data to publish
 * @returns {Promise} Promise containing the publish response
 */
export const publishReward = async (rewardData) => {
  return request(REWARDS_CONFIG.PUBLISH_REWARD, { data: rewardData })
} 

/**
 * Get reward detail from API
 * @param {Number} id - The reward id
 * @returns {Promise} Promise containing the reward detail data
 */
export const getRewardDetail = async (id) => {
  return request(REWARDS_CONFIG.GET_REWARD_DETAIL(id))
}

export const getSegmentsList = (queryParams, searchArr) =>
  request(REWARDS_CONFIG.SEGMENTS_LIST(queryParams), {data: searchArr});